import { cva } from 'class-variance-authority';

export const iconWithBackgroundVariants = cva('rounded-small', {
  variants: {
    variant: {
      main: 'bg-teal-100 [&_svg]:text-teal-500',
      secondary: 'bg-transparent [&_svg]:text-slate-400',
    },
    size: {
      xs: 'p-unit-1', //padding 2px
      sm: 'p-unit-2', //padding 4px
      md: 'p-unit-3', //padding 6px
      lg: 'p-unit-4', //padding 8px
    },
    iconSize: {
      sm: '[&_svg]:size-unit-6', //icon size 12px
      md: '[&_svg]:size-unit-8', //icon size 16px
      lg: '[&_svg]:size-unit-11', //icon size 24px
    },
  },
  defaultVariants: {
    variant: 'main',
    size: 'md',
    iconSize: 'md',
  },
});
